import { createSystem, defaultConfig } from "@chakra-ui/react";

export const system = createSystem(
  defaultConfig,
  {
    globalCss: {
      // iOS Safari zooms the whole viewport when focusing a control whose font-size is
      // below 16px. Chakra's size="sm" inputs are 14px, so bump them below the md
      // breakpoint (48em) only.
      "@media (max-width: 47.9375em)": {
        "input, select, textarea": {
          fontSize: "16px",
        },
      },
    },
    theme: {
      tokens: {
        colors: {
          orange: {
            600: { value: "#ff5400" },
          },
        },
      }
    }
  }
);
